"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("core-js/es6/promise");

require("core-js/es6/array");

require("core-js/es6/set");

var Observable =
/** @class */
function () {
  function Observable() {
    this.observers = [];
  }

  Observable.prototype.count = function () {
    return this.observers.length;
  };

  Observable.prototype.clear = function () {
    this.observers.splice(0, this.observers.length);
  };

  Observable.prototype.on = function (type, callback) {
    var _this = this;

    var _cancel = {
      cancel: function cancel() {
        var index = _this.observers.findIndex(function (item) {
          return item.id === _cancel;
        }); // If the index is larger than -1, then remove the item


        if (index > -1) {
          _this.observers.splice(index, 1);

          return true;
        } // Else the remove failed


        return false;
      }
    }; // If type is an array then push that to the observers

    if (Array.isArray(type)) {
      this.observers.push({
        id: _cancel,
        types: new Set(type.map(function (item) {
          return isObservableEvent(item) ? item.name : item;
        })),
        callback: callback
      });
    } else {
      this.observers.push({
        id: _cancel,
        types: new Set([isObservableEvent(type) ? type.name : type]),
        callback: callback
      });
    }

    return _cancel;
  };

  Observable.prototype.off = function (observer) {
    // Find the index of the array
    var index = this.observers.findIndex(function (item) {
      return item.callback === observer;
    }); // If the index is larger than -1, then remove the item

    if (index > -1) {
      this.observers.splice(index, 1);
      return true;
    } // Else the remove failed


    return false;
  };

  Observable.prototype.notify = function (event, data) {
    var _this = this; // Make function decoupled


    return Promise.resolve().then(function () {
      var types = [event.name],
          calledEventName = event.name; // Select all events to be called

      while (event.parent !== undefined && event.parent !== null) {
        event = event.parent;
        types.push(event.name);
      } // Call all observers having the type


      _this.observers.forEach(function (observer) {
        if (types.some(function (type) {
          return observer.types.has(type);
        })) {
          if (isObserver(observer.callback)) {
            observer.callback.update(data, calledEventName);
          } else {
            observer.callback(data, calledEventName);
          }
        }
      });
    });
  };

  return Observable;
}();

exports.Observable = Observable;
/**
 * Check if the item is of type IObservableEvent
 * @param tested is the parameter to be tested
 * @return {boolean} true if the item is instance of IObservableEvent, otherwise false
 */

function isObservableEvent(tested) {
  return tested !== undefined && tested !== null && tested.hasOwnProperty('name') && tested.hasOwnProperty('parent');
}
/**
 * Check if the item is of type IObserver
 * @param tested is the parameter to be tested
 * @return {boolean} true if the item is instance of IObserver, otherwise false
 */


function isObserver(tested) {
  return tested !== undefined && tested !== null && typeof tested.update === 'function';
}